import React from 'react';
import { css } from '@emotion/css';

/**
 * @brief Wrapper component that ensures everything is displayed within a A4 page layout.
 */
const Page = ({ fixedPageHeight, children }) => {
    return (
        <>
            <div
                className={css({
                    boxSizing: 'border-box',
                    width: '210mm',
                    minHeight: '297mm',
                    height: fixedPageHeight ? '297mm' : undefined,
                    padding: '17mm 24mm;', // vertical horizontal
                    backgroundColor: 'white',
                    margin: '5mm auto',
                    boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.5)',
                    '@media print': {
                        padding: 0,
                        margin: 0,
                        width: '100%',
                        minHeight: 0,
                        height: fixedPageHeight ? '262mm' : undefined,
                        pageBreakAfter: 'always',
                        boxShadow: 'none',
                    },
                })}
            >
                {children}
            </div>
        </>
    );
};

export default Page;
